import React from 'react';
import { Helmet } from 'react-helmet';
import { Card, Container } from 'react-bootstrap';

function AccessDenied() {
  return (
    <>
      <Helmet>
        <title>Access denied</title>
      </Helmet>

      <Container fluid>
        <Card>
          <Card.Header>
            <h4 className="card-header-title">
              Käyttöoikeutesi eivät riitä sivun näyttämiseen
            </h4>
          </Card.Header>
        </Card>
      </Container>
    </>
  );
}

export default AccessDenied;
